import { render, staticRenderFns } from "./RegistroCita.vue?vue&type=template&id=893e5530&scoped=true&"
import script from "./RegistroCita.vue?vue&type=script&lang=js&"
export * from "./RegistroCita.vue?vue&type=script&lang=js&"
import style0 from "./RegistroCita.vue?vue&type=style&index=0&id=893e5530&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893e5530",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
